import { FormattedMessage, useIntl } from "react-intl";

const DemoAcademic10Conclusion = (props) => {
  const intl = useIntl();
  
  return (
    <section id="demo-academic10-test-conclusion">
      
      <h1>Conclusion</h1>

      <p><FormattedMessage id="demo.academic10.conclusion.p1" /></p>
      
      <p className="margin-bottom-none"><FormattedMessage id="demo.academic10.conclusion.p2" /></p>
      <ul className="bullet ul-compact">
        <li><FormattedMessage id="demo.academic10.conclusion.ul.li1" /></li>
        <li><FormattedMessage id="demo.academic10.conclusion.ul.li2" /></li>
        <li><FormattedMessage id="demo.academic10.conclusion.ul.li3" /></li>
        <li>
          <FormattedMessage
            id="demo.academic10.conclusion.ul.li4"
            values={
              {
                Important : <strong>{intl.formatMessage({id: "demo.academic10.conclusion.ul.li4_important"})}</strong>,
                ZoomSectionLink: <a href={`https://evaluation.e-potentiel.com/faq/acad/${props.pref_lang}`}>{intl.formatMessage({id: "demo.academic10.conclusion.ul.li4_zoomSectionLink"})}</a>,
                FAQLink: <a href={`https://evaluation.e-potentiel.com/faq/acad/${props.pref_lang}`}>{intl.formatMessage({id: "demo.academic10.conclusion.FAQLink"})}</a>
              }
            }
          />
        </li>
      </ul>

      <p><FormattedMessage id="demo.academic10.conclusion.p3" values={
        {FAQLink: <a href={`https://evaluation.e-potentiel.com/faq/acad/${props.pref_lang}`}>{intl.formatMessage({id: "demo.academic10.conclusion.FAQLink"})}</a>}
      } /></p>

      <p><FormattedMessage id="demo.academic10.conclusion.p4" values={{
        StartOverButton: <strong>{intl.formatMessage({id: "demo.academic10.conclusion.startOverButton"})}</strong>
      }} /></p>

      <div className="text-center">
        <button className="bnt btn-primary btn-lg" onClick={()=>props.next()}><FormattedMessage id="demo.academic10.conclusion.startOverButton" /></button>
      </div>
    </section>
  );
};

export default DemoAcademic10Conclusion;